import React, { useState, useRef } from "react";
import styled from "styled-components";
import cameraIcon from "../../Images/camera.svg";
import minimizeSign from "../../Images/minimizeSign.svg";
import maximizeSign from "../../Images/maximizeSign.svg";
import sendIcon from "../../Images/send.png";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { useLanguage } from "../LangTranslation/LanguageContext";
import moment from "moment";

const FormSectionContainer = styled.div`
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  color: #8a94a6;
  font-weight: 400;
  .form-control {
    display: block;
    width: 100%;
    margin-top: 0px !important;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
`;
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .upload_text {
    text-align: center;
    font-size: 18px;
  }
`;
const FormSectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #000000 !important;
  margin-bottom: 0px !important;
`;
const PageLeftHalf = styled.h2`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const FormButton = styled.button`
  padding: 8px;
  margin: 10px;
  background-color: #ff5837;
  color: #fff;
  border: none;
  font-family: "Inter";
  border-radius: 15px;
  cursor: pointer;
  font-size: 18px;
  transition: background-color 0.3s ease;
`;
const LstSection = styled.div`
  display: flex;
  background-color: #fff;
  .saved_text {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 500;
    color: #b0b7c3;
    text-align: center;
    margin-top: 22px;
  }
  .left_half {
    display: flex;
    gap: 10px;
    justify-content: center;
    padding: 10px;
    width: 78%;
  }
  .right_half {
    display: flex;
    gap: 10px;
    justify-content: center;
    width: 20%;
  }
`;
const FirstSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: none;
  background-color: #fff;
  .minimize {
    padding: 0px 10px;
  }
`;

const FormSection = ({
  postDetail = {},
  commentsData = [],
  inputValue,
  setInputValue,
  handleSendMessage,
  isLoadingComments,
  scrollRef,
  selectedPost,
}) => {
  const { language, translations } = useLanguage();
  const t = translations[language];

  const [isMinimized, setIsMinimize] = useState(true);
  const postDetails = useRef();

  const handleMinimizeDetails = () => {
    setIsMinimize(!isMinimized);
  };
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };
  return (
    <PageLeftHalf>
      <FormSectionContainer>
        <FirstSection>
          <FormSectionTitle>{t["Post Details"]}</FormSectionTitle>
          <div className="minimize" onClick={() => handleMinimizeDetails()}>
            {isMinimized && <img src={maximizeSign} alt="maximize" />}
            {!isMinimized && <img src={minimizeSign} alt="minimize" />}
          </div>
        </FirstSection>
        <div
          className={`post-details ${isMinimized ? "minimized" : "maximized"}`}
          ref={postDetails}
        >
          <h3 className="postTitle text-center">
            {postDetail?.display_name || t["Display Name"]}
          </h3>
          <div className="d-flex flex-column">
            <label className="fw-bold fs-6 mb-2">{t["Description"]}:</label>
            <textarea
              id="description"
              className="form-control"
              placeholder={t["Description"]}
              value={postDetail?.description_sale || ""}
              readOnly={true}
            ></textarea>
          </div>
          <div className="d-flex flex-column">
            <label className="fw-bold fs-6 mb-2">{t["Volume"]}:</label>
            {postDetail?.volume && postDetail?.volume_uom_name ? (
              <input
                id="volume"
                className="form-control"
                placeholder={t["Volume"]}
                value={`${postDetail.volume} ${postDetail.volume_uom_name}`}
                readOnly={true}
              />
            ) : (
              <input
                id="volume"
                className="form-control"
                placeholder={t["Volume"]}
                value={""}
                readOnly={true}
              />
            )}
          </div>
          <div className="d-flex flex-column">
            <label className="fw-bold fs-6 mb-2">{t["Price"]}:</label>
            {postDetail?.lst_price && postDetail?.lst_price?.[1] ? (
              <input
                className="form-control"
                id="price"
                placeholder={t["Price"]}
                value={`${postDetail.lst_price} ${postDetail.lst_price[1]}`}
                readOnly={true}
              />
            ) : (
              <input
                className="form-control"
                id="price"
                placeholder={t["Price"]}
                value={""}
                readOnly={true}
              />
            )}
          </div>
          {/* <div>
            <input
              id="sale"
              className="form-control"
              placeholder="Sale"
              value={"10%"}
              readOnly={true}
            />
          </div> */}
          <ImageContainer>
            <img
              src={postDetail?.picture_url || cameraIcon}
              alt="post image"
              height="auto"
              width="212px"
            />
          </ImageContainer>
        </div>
      </FormSectionContainer>

      <div
        className={`${isMinimized ? "chatWrapper" : "chatWrapperMinimized"}`}
      >
        <div
          ref={scrollRef}
          className={`${isMinimized ? "chatBox" : "chatBoxMinimized"}`}
        >
          {commentsData.length > 0 ? (
            commentsData.map((comment) => (
              <div key={comment.id} className="chatItem">
                <h6 className="commenteeName text-left">
                  {comment.author ? comment.author : "Author Unkown"}
                </h6>
                <p className="comment">{comment.comment}</p>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="time text-left">
                    {moment(comment.date).fromNow()}
                  </span>
                  <span className="likes text-right fs-6 text-danger">
                    {comment.likes} <i className="bi bi-heart-fill me-1"></i>
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div
              className={`d-flex justify-content-center align-items-center w-100 h-100 fs-6 text-secondary ${
                isLoadingComments ? "flex-column" : ""
              }`}
            >
              {!isLoadingComments ? (
                t["No comments available"]
              ) : (
                <div className="spinner-border text-secondary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </div>
          )}
          {/* <div className="chatItem darker">
            <h6 className="commenteeName text-start">My-Name</h6>
            <p className="comment text-start">
              Hey! I'm fine. Thanks for asking!
            </p>
            <span className="time text-start">11:01</span>
          </div> */}
        </div>
        <LstSection>
          <div className="left_half">
            <input
              id="chatInput"
              className="form-control"
              placeholder={t["your message"]}
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
          <div
            className="right_half"
            style={{
              marginTop: "0",
              width: "50",
              background: "#fff",
            }}
          >
            {isLoadingComments || selectedPost.post_id ? (
              <FormButton
                onClick={() => handleSendMessage(inputValue)}
                disabled={true}
                className="opacity-50"
              >
                <div
                  className={`spinner-border spinner-border-sm text-light ${
                    isLoadingComments ? "me-1" : "d-none"
                  }`}
                  role="status"
                ></div>
                <span className="textFormButton">{t["Send Message"]}</span>
                <img src={sendIcon} alt="Send" className="iconFormButton" />
              </FormButton>
            ) : (
              <FormButton
                onClick={() => handleSendMessage(inputValue)}
                disabled={false}
                className="opacity-100"
              >
                <div
                  className={`spinner-border spinner-border-sm text-light ${
                    isLoadingComments ? "me-1" : "d-none"
                  }`}
                  role="status"
                ></div>
                <span className="textFormButton">{t["Send Message"]}</span>
                <img src={sendIcon} alt="Send" className="iconFormButton" />
              </FormButton>
            )}
          </div>
        </LstSection>
      </div>
    </PageLeftHalf>
  );
};

export default FormSection;
